import { IModule } from 'angular';

export module Module {

  let _instance: IModule;

  export function instance() {
    if (!_instance) {
      _instance = angular.module('VizPortal', [
        'ngCookies', 'ngSanitize']);
    }
    return _instance;
  }

}
